import { render, staticRenderFns } from "./initPrescriptionListDialog.vue?vue&type=template&id=1da3e5fe&"
import script from "./initPrescriptionListDialog.vue?vue&type=script&lang=js&"
export * from "./initPrescriptionListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports